import { Badge } from "@mantine/core";
import { useMemo } from "react";
import { HeldEmailState } from "../../../services/admin/systemEmails.service";

interface HeldEmailStateBadgeProps {
  state: HeldEmailState;
}

const STATE_DETAILS = {
  pending: { label: "Waiting for review", color: "yellow" },
  blocked: { label: "Blocked", color: "red" },
  sending: { label: "Sending", color: "blue" },
  sent: { label: "Sent", color: "green" },
  cancelled: { label: "Cancelled", color: "gray" },
  failed: { label: "Release failed", color: "orange" },
} as const;

export function HeldEmailStateBadge({ state }: HeldEmailStateBadgeProps) {
  const detail = useMemo(() => STATE_DETAILS[state], [state]);
  return (
    <Badge color={detail.color} variant="light">
      {detail.label}
    </Badge>
  );
}
